module.exports = __webpack_public_path__ + "eabd5f630de9ec64302a71d18bdcd442.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Balzano.ttf?v=1.00
// module id = 937
// module chunks = 24